<template>
  <div>
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5>Filtrar artículos</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              <label>Temática</label>
              <select
                class="form-control"
                v-model="filters.topic"
                @change="applyFilters('topic')"
              >
                <option value="all">Todos</option>
                <option
                  :key="item.id"
                  v-for="item in topics"
                  :value="item.UUID"
                >
                   {{ item.name }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label :class="{ 'text-muted': filters.topic === 'all' }">Categoría</label>
              <select
                class="form-control"
                v-model="filters.category"
                @change="applyFilters('category')"
                :disabled="filters.topic === 'all' || loading"
              >
                <option value="all">Todos</option>
                <option
                  :key="item.id"
                  v-for="item in categories"
                  :value="item.UUID"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label :class="{ 'text-muted': filters.category === 'all' }">Subcategoría</label>
              <select
                class="form-control"
                v-model="filters.subcategory"
                @change="applyFilters()"
                :disabled="filters.category === 'all' || loading"
              >
                <option value="all">Todos</option>
                <option
                  :key="item.id"
                  v-for="item in subcategories"
                  :value="item.UUID"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5>Artículos</h5>
          <AddArticle :tags="tags" :categories="categories" />
        </div>
      </div>
      <div class="card-body">
        <div v-if="!loading" class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="bg-dark text-white">
              <tr class="">
                <th class="col-flexible">Título</th>
                <th class="col-flexible">Temática</th>
                <th class="col-flexible">Categoría</th>
                <th class="col-flexible">Subcategoría</th>
                <th class="col-fixed-status">Estado</th>
                <th class="col-fixed-date">Fecha de creación</th>
                <th class="col-fixed-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr class="align-middle" :key="item" v-for="item in articles">
                <ArticleRow
                  :article="item"
                  :tags="tags"
                  :topics="topics"
                ></ArticleRow>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
            <div class="text-muted small">
              Mostrando 
              {{ (serverOptions.page - 1) * serverOptions.rowsPerPage + 1 }} - 
              {{ Math.min(serverOptions.page * serverOptions.rowsPerPage, serverItemsLength) }} 
              de {{ serverItemsLength }} resultados (artículos)
            </div>
            <div class="d-flex align-items-center gap-3 small">
              <span>líneas por página:</span>
              <select v-model.number="serverOptions.rowsPerPage" @change="applyFilters()" class="form-select form-select-sm w-auto">
                <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }}</option>
              </select>
              <button class="btn btn-sm btn-light" :disabled="serverOptions.page === 1" @click="changePage(serverOptions.page - 1)">
                <i class="fa fa-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-light" :disabled="serverOptions.page * serverOptions.rowsPerPage >= serverItemsLength" @click="changePage(serverOptions.page + 1)">
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div>Cargando información</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddArticle from "@/components/Blog/elements/Articles/AddArticle.vue";
import ArticleRow from "@/components/Blog/elements/Articles/ArticleRow.vue";

import ArticleService from "@/services/article.service.js";
import CategoryService from "@/services/category.service";
import SubCategoryService from "@/services/subcategory.service";
import TagService from "@/services/tag.service";
import TopicService from "@/services/topic.service";

export default {
  name: "Articles",
  components: {
    AddArticle: AddArticle,
    ArticleRow: ArticleRow,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      articles: [],
      tags: [],
      categories: [],
      subcategories: [],
      topics: [],
      filters: {
        topic: "all",
        category: "all",
        subcategory: "all",
      },
      loading: true,
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 10,
      },
    };
  },
  methods: {
    async start() {
      this.loading = true;
      if (localStorage.getItem("filters_topic") != null) {
        this.filters.topic = localStorage.getItem("filters_topic");
      }
      if (localStorage.getItem("filters_category") != null) {
        this.filters.category = localStorage.getItem("filters_category");
      }
      if (localStorage.getItem("filters_subcategory") != null) {
        this.filters.subcategory = localStorage.getItem("filters_subcategory");
      }
      await this.getTopics();
      await this.getTags();
      await this.applyFilters();
      this.loading = false;
    },

    async getArticles(params = {}) {
      // Use serverOptions values
      params.page = this.serverOptions.page;
      params.page_size = this.serverOptions.rowsPerPage;

      var response = await ArticleService.getAllArticles(params);
      
      // Map to the new keys from backend
      this.articles = response.data.items;
      // console.log(this.articles, "this.articles")
      this.serverItemsLength = response.data.serverItemsLength;
      this.serverOptions.page = response.data.current_page;
    }, 
    async getTags() {
      this.tags = await TagService.getAllTags();
      this.tags = this.tags.data;
    },
    async getCategories(params) {
      var response = await CategoryService.getAllCategories(params);
      this.categories = [];
      this.categories = response.data;
    },
    async getSubCategories(params) {
      var response = await SubCategoryService.getAllSubCategories(params);
      this.subcategories = [];
      this.subcategories = response.data;
    },
    async getTopics() {
      var response = await TopicService.getAllTopics();
      this.topics = response.data;
    },

    async applyFilters(key = null) {
      this.loading = true;
      this.serverOptions.page = 1;
      if (key == "topic") {
        this.categories = [];
        this.filters.category = "all";

        this.subcategories = [];
        this.filters.subcategory = "all";
      } else if (key == "category") {
        this.subcategories = [];
        this.filters.subcategory = "all";
      }

      if (
        this.filters.topic != "all" &&
        this.filters.category != "all" &&
        this.filters.subcategory != "all"
      ) {
        await this.getArticles({
          topic: this.filters.topic,
          category: this.filters.category,
          subcategory: this.filters.subcategory,
        });
      } else if (
        this.filters.topic != "all" &&
        this.filters.category != "all"
      ) {
        await this.getCategories({
          topic: this.filters.topic,
        });
        await this.getSubCategories({
          topic: this.filters.topic,
          category: this.filters.category,
        });

        await this.getArticles({
          topic: this.filters.topic,
          category: this.filters.category,
        });
      } else if (this.filters.topic != "all") {
        await this.getCategories({
          topic: this.filters.topic,
        });
        this.subcategories = [];
        this.filters.subcategory = "all";

        await this.getArticles({
          topic: this.filters.topic,
        });
      } else {
        this.topic = [];
        this.filters.topic = "all";

        this.categories = [];
        this.filters.category = "all";

        this.subcategories = [];
        this.filters.subcategory = "all";

        await this.getArticles();
      }

      localStorage.setItem("filters_topic", this.filters.topic);
      localStorage.setItem("filters_category", this.filters.category);
      localStorage.setItem("filters_subcategory", this.filters.subcategory);

      this.loading = false;
    },
    async changePage(newPage) {
      this.loading = true;
      this.serverOptions.page = newPage;
      await this.getArticles({
        topic: this.filters.topic,
        category: this.filters.category,
        subcategory: this.filters.subcategory
      });
      this.loading = false;
    },
  },
  created() {
    this.start();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.table {
  font-size: 0.9rem; /* Slightly smaller than default */
  table-layout: fixed; /* Necessary to force exact column widths */
  width: 100%;
}

/* Force text wrapping for flexible columns so they don't break layout */
.table td, .table th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}

/* The first 4 columns share equal remaining space */
.col-flexible {
  width: 18%; /* Adjusting so total doesn't exceed 100% */
}

.col-fixed-status {
  width: 30px;
  text-align: center;
}

.col-fixed-date {
  width: 60px;
  text-align: center;
}

.col-fixed-actions {
  width: 40px;
  text-align: center;
}

select:disabled {
  cursor: not-allowed;
  background-color: #e9ecef;
  opacity: 1;
}

label.text-muted {
  cursor: not-allowed;
}
</style>